import React, { useContext } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import { Context } from '@components/Context';
import Colors from '@components/shared/Colors';
import RemoveIcon from '@images/remove-icon.svg';

interface Props {
  titleKey: string;
  isSubscription: boolean;
}

const CartSectionHeading: React.FC<Props> = ({ titleKey, isSubscription }) => {
  const { t } = useTranslation();
  const { dispatch } = useContext(Context);

  function removeSubscription() {
    dispatch({ type: 'setSelectedPlan', data: '' });
    dispatch({ type: 'setSelectedBox', data: undefined });
  }

  return (
    <SectionHeading>
      <span>{t(titleKey)}</span>
      {isSubscription && (
        <RemoveOption onClick={() => removeSubscription()}>
          <RemoveIcon
            style={{
              marginRight: 3,
              height: 14,
              width: 14,
              verticalAlign: -3
            }}
          />
        </RemoveOption>
      )}
    </SectionHeading>
  );
};

export default CartSectionHeading;

const SectionHeading = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 12px;

  span {
    font-family: 'BrownStd';
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 1px;
    text-align: left;
    text-transform: uppercase;
    color: inherit;
  }
`;

const RemoveOption = styled.button`
  font-size: 12px;
  line-height: 1;
  color: ${Colors.darkGreen};
  font-family: 'BrownStd';
  font-weight: bold;
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
  opacity: 0.5;

  &:hover {
    opacity: 1;
  }
`;
